import { setAuthRefreshHandler } from '../services/api';

export function setupAuthRefresh(refreshTokenFn) {
  // Set up the auth refresh handler
  setAuthRefreshHandler(refreshTokenFn);
} 